import { HHStack } from '@hinge-health/react-component-library';
import { ActiveContractLabels } from '../../../constants/strings/billing-label-enums';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../../utils/bills-utils';
import { TextGrouping } from '../../utils/text-grouping';

interface CostShareOptionsDisplayProps {
  cadence: string;
  deductionTiming: string;
}

export const CostShareOptionsDisplay = ({
  cadence,
  deductionTiming,
}: CostShareOptionsDisplayProps): JSX.Element => (
  <HHStack direction="column" gap={2}>
    <HHStack display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={0}>
      <TextGrouping
        label={ActiveContractLabels.CADENCE_LABEL}
        text={capitalizeFirstLetterAndSpaceSnakeString(cadence)}
      />
      <TextGrouping
        label={ActiveContractLabels.DEDUCTION_TIMING_LABEL}
        text={capitalizeFirstLetterAndSpaceSnakeString(deductionTiming)}
      />
    </HHStack>
  </HHStack>
);

export const CostShareOptionsDisplaySingleRow = ({
  cadence,
  deductionTiming,
}: CostShareOptionsDisplayProps): JSX.Element => (
  <>
    <TextGrouping
      label={ActiveContractLabels.CADENCE_LABEL}
      text={capitalizeFirstLetterAndSpaceSnakeString(cadence)}
    />
    <TextGrouping
      label={ActiveContractLabels.DEDUCTION_TIMING_LABEL}
      text={capitalizeFirstLetterAndSpaceSnakeString(deductionTiming)}
    />
  </>
);
